import { render, staticRenderFns } from "./payjp-card-and-paypay-form.vue?vue&type=template&id=2fd29912&scoped=true&lang=pug&"
import script from "./payjp-card-and-paypay-form.vue?vue&type=script&lang=js&"
export * from "./payjp-card-and-paypay-form.vue?vue&type=script&lang=js&"
import style0 from "./payjp-card-and-paypay-form.vue?vue&type=style&index=0&id=2fd29912&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd29912",
  null
  
)

export default component.exports